import {
    BreadCrumbItem,
    BreadCrumbs as BreadCrumbsComponent,
} from '@eventbrite/breadcrumbs-infra';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

interface BreadCrumbContainerProps {
    locationSlug: string;
    currentPlace: string;
}

const BreadCrumbs: React.FunctionComponent<BreadCrumbContainerProps> = (
    props,
) => {
    const locationSlug = props.locationSlug;
    const currentPlace = props.currentPlace;

    const breadcrumbItems = React.useMemo<BreadCrumbItem<{}>[]>(() => {
        return [
            { value: '/', display: gettext('Home') },
            { value: `/d/${locationSlug}/events`, display: currentPlace },
        ];
    }, [locationSlug, currentPlace]);

    return (
        <BreadCrumbsComponent
            items={breadcrumbItems}
            separator={
                <span style={{ paddingLeft: '8px', paddingRight: '8px' }}>
                    /
                </span>
            }
            data-testid="city-browse-header"
            shouldIncludeMicroData={true}
        >
            {(item) => (
                <Link {...item.valueMicrodataProps} to={item.value}>
                    {item.displayWithMicroData}
                </Link>
            )}
        </BreadCrumbsComponent>
    );
};

interface AppState {
    location: {
        slug: string;
        currentPlace: string;
    };
}

const _mapStateToProps = (state: AppState) => ({
    locationSlug: state.location.slug,
    currentPlace: state.location.currentPlace,
});

export const BreadCrumbContainer = connect(_mapStateToProps)(BreadCrumbs);
